<div class="login-page">
  <div class="login-shell">
    <section class="login-intro">
        <div class="intro-visual" aria-hidden="true">
            <span class="orb orb-1"></span>
            <span class="orb orb-2"></span>
            <span class="orb orb-3"></span>
            <div class="intro-badge">
                <span class="wave"></span>
                <span class="wave"></span>
                <span class="wave"></span>
                <i class="fa fa-lock"></i>
            </div>
        </div>

        <div class="intro-copy">
            <h2>Welcome to Sovos</h2>
            <p>One secure identity for every Sovos product. Sign in with your credentials,
                Sovos Identity, or your organisation's SAML provider.</p>
            <ul class="intro-points">
                <li><i class="fa fa-shield"></i><span>Enterprise-grade security</span></li>
                <li><i class="fa fa-users"></i><span>Single account across products</span></li>
                <li><i class="fa fa-bolt"></i><span>Fast, seamless single sign-on</span></li>
            </ul>
        </div>
    </section>

    <section class="login-panel">
        <div class="login-brand">
            <img src="assets/images/sovos-logo-dark.png" alt="Sovos">
        </div>

        <ng-container *ngIf="!showLoginForm">
            <h1 class="login-title mb-2">Sign in</h1>
            <p class="login-subtitle ng-star-inserted">Choose how you would like to continue</p>
            <div class="login-actions">
               <button class="login-btn login-btn-primary" type="button" (click)="signInSovosIdentity()"><i class="fa fa-key btn-icon"></i><span>New Login - Sovos Identity</span><i class="fa fa-arrow-right btn-arrow"></i></button>
                <div class="login-divider">OR</div>
                <button class="login-btn login-btn-primary" type="button" (click)="openLoginForm()"><i class="fa fa-id-badge btn-icon"></i><span>Existing Login</span><i class="fa fa-arrow-right btn-arrow"></i></button>
                <div class="login-divider">OR</div>
                <button class="login-btn login-btn-primary" type="button" (click)="signInSAML()"><i class="fa fa-shield btn-icon"></i><span>SAML Login</span><i class="fa fa-arrow-right btn-arrow"></i></button>
            </div>
        </ng-container>

        <form *ngIf="showLoginForm" [formGroup]="loginForm" class="login-form" autocomplete="off"
            (ngSubmit)="login()">
            <button type="button" class="login-back" (click)="backToOptions()">
                <i class="fa fa-angle-left"></i>
                <span>Back</span>
            </button>

            <h1 class="login-title">Sign in</h1>

            <div class="login-field">
                <label for="exampleInputEmail">Username</label>
                <input type="text" class="login-input" formControlName="email" id="exampleInputEmail"
                    placeholder="Username" autocomplete="username" autocorrect="off" autocapitalize="off"
                    spellcheck="false">
                <div *ngIf="isSubmitted">
                    <span class="login-error"
                        *ngIf="!loginForm.get('email').dirty && loginForm.get('email').errors?.required">Email
                        Required
                    </span>
                    <span class="login-error"
                        *ngIf="loginForm.get('email').dirty && loginForm.get('email').errors">Invalid
                        Email
                    </span>
                </div>
            </div>

            <div class="login-field">
                <label for="exampleInputPassword">Password</label>
                <input type="password" class="login-input passdisc" formControlName="password"
                    id="exampleInputPassword" placeholder="Password" maxlength="16" autocomplete="current-password"
                    autocorrect="off" autocapitalize="off" spellcheck="false">
                <div *ngIf="isSubmitted">
                    <span class="login-error"
                        *ngIf="!loginForm.get('password').dirty && loginForm.get('password').errors?.required">Password
                        Required
                    </span>
                    <span class="login-error"
                        *ngIf="loginForm.get('password').dirty && loginForm.get('password').errors">Invalid
                        Password
                    </span>
                </div>
            </div>

            <button type="submit" class="login-btn login-btn-primary justify-content-center">SIGN IN </button>

            <div class="login-links">
                <a (click)="forgotPassword()">Forgot password?</a>
            </div>
        </form>
    </section>
  </div>
</div>

<p-dialog [(visible)]="displayConsentModal" [modal]="true" [closable]="true" [draggable]="false" [resizable]="false" header="Consent Box">
    <div class="form-check form-constent-sign-in">
        <input type="checkbox" class="form-check-input" id="consentGiven" [(ngModel)]="isChecked" [ngModelOptions]="{standalone: true}" />
        <label class="form-check-label form-constent-sign-in-label" for="consentGiven">
          In compliance with the Information Technology Act 2000 and related
          rules, we seek your consent to collect and use
          your personal data (e.g. email ID, mobile number) for authentication,
          notifications, and service facilitation on
          our platform. By providing your personal data, you agree to its
          collection, use, processing, and storage as per our
          <a class="text-decoration-underline" href="https://www.sovos.com/software-and-services-terms/"
              target="_blank"> Terms & Conditions </a> and <a class="text-decoration-underline"
              href="https://sovos.com/software-and-services-terms/data-privacy/" target="_blank"> Privacy Policy </a>. Your data will not be disclosed
          without your explicit consent unless required
          by law.
        </label>
    </div>
    <div *ngIf="isSubmittedConsent && !isChecked" style="margin-left: 18px;">
        <span class="text-danger"> Consent
            Required
        </span>
    </div>
    <p-footer>
        <button type="button" [ngClass]="{'disabled-btn': !isChecked}" (click)="hideConsentModal()" class="btn btn-primary" [disabled]="!isChecked" data-dismiss="modal">Confirm</button>
    </p-footer>
</p-dialog>
